var getApiUrl = process.env.VUE_APP_API_URL // API域名
var cdnUrl = process.env.VUE_APP_CDN_URL_PIC // 图片地址
var shareUrl = process.env.VUE_APP_SHARE_URL // H5
var upJmdyh = process.env.VUE_APP_UP_JMDYH // 订阅号后台跳转域名
var Jmdyh = process.env.VUE_APP_JMDYH // 订阅号跳转域名
var feemooUrl = process.env.VUE_APP_FEEMOO // 海外地址
var fmUrl = process.env.VUE_APP_FMY // 国内地址
var cmUrl = process.env.VUE_APP_CLOUDMASTER// 达人地址
var fmCookieName = process.env.VUE_APP_SOTOOKEN // token名称
export default {
  getApiUrl,
  cdnUrl,
  shareUrl,
  upJmdyh,
  Jmdyh,
  feemooUrl,
  fmUrl,
  cmUrl,
  fmCookieName,
}
